import { RoundCheck } from './RoundCheck';

export interface SuccessCheckProps {
  size?: number;
}

export const SuccessCheck = ({ size }: SuccessCheckProps) => {
  return <RoundCheck size={size} color="var(--color)" showCheck />;
};
